import React from 'react';

import bg1 from './assets/images/playlist-card-bg_01.png';
import bg2 from './assets/images/playlist-card-bg_02.png';
import bg3 from './assets/images/playlist-card-bg_03.png';
import bg4 from './assets/images/playlist-card-bg_04.png';

interface PlaylistItemProps {
  title: string;
  url?: string;
  index: number;
  icon?: string;
}

function PlaylistItem({ title, url, index, icon }: PlaylistItemProps) {
  const backgrounds = [bg1, bg2, bg3, bg4];

  const TagCard = url ? 'a' : 'div';
  const bgColor =
    typeof backgrounds[+index % 4] === 'string'
      ? backgrounds[+index % 4]
      : backgrounds[+index % 4].src;

  return (
    <div
      className="au-text-center au-h-[91%] md:au-w-full sm:!au-w-full"
      style={{
        backgroundImage: `url("${bgColor}")`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
      }}
    >
      <TagCard
        className={`au-flex au-flex-col au-h-full au-px-7 au-py-10 au-border au-border-solid au-border-gray-200 au-rounded-lg ${bgColor}`}
        {...(url && { href: url })}
      >
        <div className="au-font-bold au-leading-8 md:au-w-4/5 au-mx-auto au-mb-10 au-text-2xl au-text-[#dedede] au-text-[26px]">
          {title}
        </div>
        {icon && (
          <img
            src={icon}
            className="au-mx-auto au-mt-auto au-w-[50px]"
            alt=""
          />
        )}
      </TagCard>
    </div>
  );
}

export default PlaylistItem;
